const BaseUrl =
  process.env.GATSBY_ENV === 'production'
    ? 'https://commmune.jp'
    : 'http://localhost:8000'

export default BaseUrl
